import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from '../shared/services/base.service';
import { EstimativaCronogramaKey } from '../models/estimativa-cronograma-key.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class EstimativaCronogramaKeyService extends BaseService<EstimativaCronogramaKey> {

    constructor(protected injector: Injector) {
        super(`${environment.API_PRICE}/EstimativaCronogramaKey`, injector);
    }

    update(entity: EstimativaCronogramaKey): Observable<EstimativaCronogramaKey> {
        return this.http.put<EstimativaCronogramaKey>(`${environment.API_PRICE}/EstimativaCronogramaKey/Update`, entity);
    }
}